import React, { useEffect, useState } from 'react'
import { Modal } from '@mui/material'
import { useGetRequest } from '../../../shared/hooks/requests'
import { TENANT_ANALYTICS_ATTTENDANCE_MTTS } from '../../../shared/utils/urls'
import Table from '../../../shared/ui/Table'
import { DuplicateImagesTableItems } from './DuplicateImagesTableItems'
import { XIconSizeM } from '../../../components/svgs/Svgs'
import { UpdateDuplicates } from '../features/UpdateDuplicates'

const cols = [
    { id: 1, title: 'Main Photo' },
    { id: 2, title: 'Snapshot' },
    { id: 3, title: 'Full name' },
    { id: 4, title: 'Attendance Datetime' },
    { id: 5, title: 'CreatedAt' },
    { id: 6, title: 'App VersionCode' },
    { id: 7, title: 'Device ID' },
    { id: 8, title: 'Device Name' },
    { id: 10, title: 'Distance Location' },
    { id: 11, title: 'External ID' },
    { id: 12, title: 'Image size Type*' },
]

export function DuplicateImagesModal({ entityId, startDate, endDate }) {
    const [page, setPage] = useState(1)
    const [pageSize, setPageSize] = useState(10)
    const [open, setOpen] = useState(false)
    const [selectedIds, setSelectedIds] = useState([])

    const getAttendances = useGetRequest()
    const attendances = getAttendances.response?.items || []
    const total = getAttendances.response?.total || 0

    const fetchData = () => {
        getAttendances.request({
            url: TENANT_ANALYTICS_ATTTENDANCE_MTTS,
            params: {
                tenant_entity_id: entityId,
                start_date: startDate,
                end_date: endDate,
                page,
                size: pageSize,
            },
        })
    }

    const handleOpen = () => {
        setOpen(true)
        fetchData()
    }

    useEffect(() => {
        if (entityId && open) {
            fetchData()
        }
    }, [page, pageSize])

    const handleSelect = (selected) => {
        if (!selected) return
        const ids = Array.isArray(selected)
            ? selected.map((item) => item.id)
            : [selected.id]
        setSelectedIds(ids)
    }

    const handleSelectAll = (selectedAll) => {
        const ids = selectedAll.map((item) => item.id)
        setSelectedIds(ids)
    }

    return (
        <>
            <button
                onClick={handleOpen}
                className="py-[10px] px-[15px] rounded-[10px] text-white font-[500] bg-main-100"
            >
                Details
            </button>

            <Modal
                open={open}
                onClose={() => setOpen(false)}
                className="flex items-center justify-center"
            >
                <div className="w-[82%] max-h-[80%] flex flex-col rounded-[10px]
                 overflow-hidden items-center gap-[10px] bg-white"
                >
                    <div className="w-full h-auto flex items-center justify-between px-[20px] py-[10px] bg-main-100">
                        <span className="text-[16px] font-[500] text-white">Duplicated Attendances</span>
                        <XIconSizeM onClick={() => setOpen(false)} />
                    </div>

                    <div className="w-full max-h-[80%] overflow-auto p-[10px]">
                        <Table
                            page={page - 1}
                            rowsPerPage={pageSize}
                            onPageChange={(e, newPage) => setPage(newPage + 1)}
                            onRowsPerPageChange={(e) => {
                                setPageSize(parseInt(e.target.value, 10))
                                setPage(1)
                            }}
                            cols={cols}
                            totalCount={total}
                            loading={getAttendances.loading}
                            rows={attendances}
                            withCheckbox
                            onSelect={handleSelect}
                            onSelectAll={handleSelectAll}
                            renderItem={(item) => (
                                <React.Fragment key={item.id}>
                                    <DuplicateImagesTableItems item={item} />
                                </React.Fragment>
                            )}
                        />
                    </div>

                    <div className="w-full flex items-center py-[10px] px-[20px]">
                        <UpdateDuplicates
                            ids={selectedIds}
                            onSuccess={fetchData} // refetch on success
                        />
                    </div>
                </div>
            </Modal>
        </>
    )
}
